<script lang="ts">
	export let loadMorePosts: () => void;
	let showOverlay = false;

	function handleKeyup(event: KeyboardEvent) {
		if (event.key === 'Enter') {
			loadMorePosts();
		}
	}
	// Simplify handleClick since we only want it to show overlay
	function handleClick() {
		showOverlay = true;
	}

	function closeOverlay() {
		showOverlay = false;
	}
</script>

<div class="h-18 mt-4 2xl:mt-10 md:pt-8 lg:pt-10 mb-10">
	<div
		class="
            flex flex-col
            h-full w-full
            items-center justify-center"
	>
		<button
			class="border-none cursor-pointer transition duration-300 ease-in-out transform hover:scale-105"
			on:click|preventDefault={loadMorePosts}
			on:keyup|preventDefault={handleKeyup}
		>
			<div class="my-2 items-center justify-center">
				<a data-sveltekit-preload-data="tap" href="/communityposts">
					<svg
						class="
					h-20 lg:h-24 mx-auto"
						data-name="Layer 1"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 242.02 269.71"
						><g data-name="Layer 2"
							><g data-name="Layer 1-2"
								><path
									d="M132.71 60.24c9.71-8.75 26.33-23 28.26-24.75 4.74-4.3 8-9.69 8.88-13.58C173.25 7.31 163.61 0 159.13 0c0 2.09-1.84 4.44-6.73 8.64-3.49 3-17.79 14.9-25.16 21.36-6.58 5.73-7.34 9.42-7.34 14.37 0-4.95-.77-8.64-7.35-14.37-7.37-6.42-21.7-18.36-25.16-21.32C82.5 4.44 80.66 2.09 80.66 0c-4.48 0-14.12 7.31-10.75 21.91.91 3.89 4.14 9.28 8.88 13.58 1.93 1.75 18.55 16 28.26 24.75a58.71 58.71 0 0 1 12.82 16 58.82 58.82 0 0 1 12.84-16Z"
									style="fill:#9de0f4"
								/><path
									d="M142.14 137.42c16.78-14.59 45.49-38.34 48.82-41.26 8.2-7.18 13.25-15.39 14.44-22.09 3-16.8-9.08-27.93-16.69-28.06-.06 3.56-3.27 7.49-11.71 14.49-6 5-30.71 24.83-43.43 35.53-10.81 9.09-13.31 15.18-13.66 23-.35-7.82-2.88-13.91-13.69-23C93.5 85.33 68.76 65.45 62.79 60.5c-8.44-7-11.65-10.93-11.71-14.5-7.61.13-19.68 11.26-16.69 28.06 1.19 6.7 6.24 14.91 14.44 22.09 3.33 2.92 32 26.67 48.82 41.26a108.62 108.62 0 0 1 21.76 26 .56.56 0 0 0 .75.25.55.55 0 0 0 .25-.25 110.18 110.18 0 0 1 21.73-25.99Z"
									style="fill:#54c7ea"
								/><path
									d="M153.38 232.21C177.91 210.09 220 174 224.91 169.6c12-10.89 17.2-23.09 17.11-33.21-.23-26.27-19.82-32.3-21.76-32.3 0 5.3-4.67 11.22-17 21.85-8.75 7.51-45 37.72-63.66 54-16.66 14.51-18.6 23.82-18.6 36.37 0-12.55-1.94-21.86-18.6-36.37-18.64-16.24-54.9-46.45-63.65-54-12.37-10.63-17-16.55-17-21.85-1.94 0-21.53 6-21.76 32.3-.09 10.12 5.12 22.32 17.11 33.21 4.89 4.43 47 40.49 71.52 62.61 17.27 15.56 27 29.7 30.71 36.49a1.94 1.94 0 0 0 3.41 0c3.6-6.79 13.37-20.93 30.64-36.49Z"
									style="fill:#29aae1"
								/></g
							></g
						></svg
					>
				</a>
			</div>
			<div
				class="my-1 mx-auto text-md lg:text-xl tracking-tight font-base font-exo-2 font-semibold text-bloomBlueLightActive
			pt-1 lg:pt-3 pb-2 xl:pb-4"
			>
				Read more
			</div>
		</button>
	</div>
	<div
		class="my-1 mx-auto text-sm lg:text-lg 3xl:text-lg tracking-tight font-base font-exo-2 font-semibold text-bloomGreenNormal
pb-2 xl:pb-4"
		on:click|preventDefault={handleClick}
		on:keyup|preventDefault={handleKeyup}
		role="button"
		tabindex="0"
	>
		... or Go outside 🌳 🏃🏾‍♀️ 🚲 🌸
	</div>
</div>

{#if showOverlay}
	<div
		class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50"
		on:click={closeOverlay}
		on:keyup|preventDefault={closeOverlay}
		role="button"
		tabindex="0"
	>
		<div
			class="p-8 rounded-lg shadow-xl text-center bg-bloomGreenNormal text-cosmicPurple800 font-exo-2 font-bold"
		>
			<!-- <h2 class="text-2xl mb-4">🌿 Time for a break! 🌞</h2> -->
			<p class="mb-4">You've chosen the path of</p>
			<p class="mb-4">Go outside 🌳 🏃🏾‍♀️ 🚲 🌸</p>
			<button
				class="text-sm text-cosmicPurple800 hover:text-gray-700 border-none font-normal"
				on:click={closeOverlay}
			>
				You're welcome to write about your experience here when you get back. Perhaps you found a
				poem :)
				<br /><br />
				(click anywhere to return)
			</button>
		</div>
	</div>
{/if}
